import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Skeleton from '@mlb/react-patterns/components/Skeleton/skeleton.tsx';
import COLORS from '@mlb/react-patterns/style/universal.color';

import { useImageUtils } from '../../hooks';
import Card from '../AspectRatioCard';

const BASE_WIDTH = 167;
const BASE_HEIGHT = 229;
const ASPECT_RATIO = `${BASE_WIDTH}:${BASE_HEIGHT}`;

const Image = styled.img`
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
    mask: linear-gradient(0deg,rgba(0,0,0,0) 0%,#000000 63.75%);
`;

const TextWrapper = styled.div`
    position: absolute;
    padding: 16px;
    left: 0;
    bottom: 0;
    font-family: ${({ theme }) => theme?.fonts?.family?.primary};
    word-break: break-word;
`;

const P = styled.p`
    color: ${({ theme }) => theme?.primaryTextColor};
    margin: 0;
    padding: 0;
`;

const CategoryTitle = styled(P)`
    font-size: 17px;
    font-weight: 600;
    line-height: 25px;
`;

const VideoCount = styled(P)`
    font-size: 12px;
    color: ${COLORS.mlbGrey3};
`;

const CategoryCard = (props) => {

    const {
        category,
        imageTemplateUrl: templateUrl,
        imgSizes,
        imageWidths,
        loading,
        count,
        ...otherProps
    } = props;

    const { formatImageUrl } = useImageUtils();

    const imageSrc = formatImageUrl({
        templateUrl,
        width: imageWidths[imageWidths.length - 1],
        aspectRatio: ASPECT_RATIO,
    });
    const imageSrcSet = imageWidths.map((width) => `${formatImageUrl({
        templateUrl,
        width,
        aspectRatio: ASPECT_RATIO,
    })} ${width}w`).join(', ');

    return (
        <Card
            aspectRatio={ASPECT_RATIO}
            {...otherProps}
        >
            { loading ? (
                <Skeleton margin={0} />
            ) : (
                <>
                    <Image
                        alt={category}
                        src={imageSrc}
                        srcSet={imageSrcSet}
                        sizes={imgSizes}
                        loading="lazy"
                    />
                    <TextWrapper>
                        <CategoryTitle>{category}</CategoryTitle>
                        <VideoCount>
                            {`${count} `} {count === 1 ? 'Video' : 'Videos'}
                        </VideoCount>
                    </TextWrapper>
                </>
            )}
        </Card>
    );

};

CategoryCard.propTypes = {
    count: PropTypes.number,
    category: PropTypes.string,
    imageTemplateUrl: PropTypes.string,
    imgSizes: PropTypes.string,
    imageWidths: PropTypes.array,
    loading: PropTypes.bool,
};

CategoryCard.defaultProps = {
    loading: false,
    count: 0,
    imageWidths: [
        120,
        168,
        372,
        640,
    ],
};

export default CategoryCard;
